// extracted by mini-css-extract-plugin
export default {"getStarted":"getStarted_getStarted__4AC6M","getStartedBtn":"getStarted_getStartedBtn__t2cRk","continueButton":"getStarted_continueButton__n7WXd"};